// extracted by mini-css-extract-plugin
export default {"heading":"SowuDn0TwfEJuZUGl53g"};